import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import tz from 'dayjs/plugin/timezone'
import weekday from 'dayjs/plugin/weekday'
dayjs.extend(utc)
dayjs.extend(tz)
dayjs.extend(weekday)

const changePriorityWindowToggle = (mode) => {
  const changePriorityWindow = document.getElementById('order_change_priority_window')

  if( changePriorityWindow ) {
    if( mode === 'show' ) {
      changePriorityWindow.classList.add('visible')
    }
    else {
      changePriorityWindow.classList.remove('visible')
    }
  }
}

let changePrioritySelect = (event) => {
  let hours = 72
  let priority = ''

  if( event ) {
    priority = event.target.value
  }
  else {
    const priorityElement = document.getElementById('order_change_priority_select')
    if( priorityElement ) {
      priority = priorityElement.value
    }
  }

  if( priority === 'low' ) {
    hours = 72
  }
  else if( priority === 'regular' ) {
    hours = 48
  }
  else if( priority === 'urgent' ) {
    hours = 24
  }
  else if( priority === 'express' ) {
    hours = 6
  }

  let dateNeeded = dayjs().add(hours, 'hours').tz("Europe/Vienna")


  //let dateNeededBefore = dayjs().add(hours, 'hours').tz("Europe/Vienna")

  //console.log('dateNeeded before: ' + dateNeededBefore.format('YYYY-MM-DD HH:mm'))

  let weekDay = dayjs().tz("Europe/Vienna").day();

  if( priority === 'express' ) {
    let dateFriday = '';
    if( weekDay == 5 ) {
      dateFriday = dayjs().tz("Europe/Vienna").hour(17).minute(0)
    }
    else {
      dateFriday = dayjs().tz("Europe/Vienna").weekday(6).hour(17).minute(0);
    }

    //console.log('dateFriday: ' + dateFriday.format('YYYY-MM-DD HH:mm'))

    if( dateNeeded.isAfter(dateFriday) ) {
      //console.log('+++')
      let dateMonday = dateFriday.tz("Europe/Vienna").add(64, 'hours');

      //console.log('dateMonday: ' + dateMonday.format('YYYY-MM-DD HH:mm'))

      dateNeeded = dateMonday.add(6, 'hours')
    }

    //console.log('dateNeeded after: ' + dateNeeded.format('YYYY-MM-DD HH:mm'))
  }
  else {
    let dateSaturday = '';
    if( weekDay == 6 ) {
      dateSaturday = dayjs().tz("Europe/Vienna").hour(14).minute(0)
    }
    else {
      dateSaturday = dayjs().tz("Europe/Vienna").weekday(6).hour(14).minute(0);
    }

    //console.log('dateSaturday: ' + dateSaturday.format('YYYY-MM-DD HH:mm'))

    if( dateNeeded.isAfter(dateSaturday) ) {
      //console.log('+++')
      dateNeeded = dateNeeded.add(48, 'hours')
    }

    //console.log('dateNeeded after: ' + dateNeeded.format('YYYY-MM-DD HH:mm'))
  }

  //console.log(dateNeeded.format('YYYY-MM-DD HH:mm'))

  const neededDate = document.getElementById('order_change_priority_needed_date')
  const neededTime = document.getElementById('order_change_priority_needed_time')
  if( neededDate && neededTime ) {
    neededDate.innerText = dateNeeded.format('YYYY-MM-DD')
    neededTime.innerText = dateNeeded.format('HH:mm')
  }
}

const changePriorityInit = () => {
  const changePriorityBtnNo = document.getElementById('change-priority-button-no')
  if( changePriorityBtnNo ) {
    changePriorityBtnNo.addEventListener('click', (event)=>{
      changePriorityWindowToggle('hide')
    })
  }

  let priorityElement = document.getElementById('order_change_priority_select')
  priorityElement && priorityElement.addEventListener('change', changePrioritySelect)
  changePrioritySelect()
}


export {
  changePriorityWindowToggle,
  changePriorityInit,
}

